import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/companyNotice/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/companyNotice/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/companyNotice/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/companyNotice/save', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/companyNotice/update', params, options);
export const updateReleased = (params, options) =>
  request.post('/api/v4ward/companyNotice/updateReleased', params, options);

export const updateUnpublished = (params, options) =>
  request.post('/api/v4ward/companyNotice/updateUnpublished', params, options);
